import { render, staticRenderFns } from "./TasksReport.vue?vue&type=template&id=727bdd2c&scoped=true"
import script from "./TasksReport.vue?vue&type=script&lang=js"
export * from "./TasksReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727bdd2c",
  null
  
)

export default component.exports